import { render, staticRenderFns } from "./TreatmentList.vue?vue&type=template&id=731629c4&scoped=true&"
import script from "./TreatmentList.vue?vue&type=script&lang=js&"
export * from "./TreatmentList.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentList.vue?vue&type=style&index=0&id=731629c4&lang=scss&scoped=true&"
import style1 from "./TreatmentList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731629c4",
  null
  
)

export default component.exports